import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IConfigurationCreateOrUpdateDto, IConfigurationDto, IPageDto } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class ConfigurationService {
  private baseRoute = `/api/configurations`;
  constructor(private http: HttpClient) {}

  get(pageIndex: number = -1, pageSize: number = -1, searchTerm?: string): Observable<IPageDto<IConfigurationDto>> {
    let params = new HttpParams().append("pageIndex", pageIndex.toString()).append("pageSize", pageSize.toString());
    if (!!searchTerm) {
      params = params.append("filter", searchTerm);
    }
    return this.http.get<IPageDto<IConfigurationDto>>(this.baseRoute, { params });
  }

  getById(id: string): Observable<IConfigurationDto> {
    return this.http.get<IConfigurationDto>(`${this.baseRoute}/${id}`);
  }

  create(dto: IConfigurationCreateOrUpdateDto): Observable<IConfigurationDto> {
    return this.http.post<any>(`${this.baseRoute}`, dto);
  }

  update(id: string, dto: IConfigurationCreateOrUpdateDto): Observable<void> {
    return this.http.put<any>(`${this.baseRoute}/${id}`, dto);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<any>(`${this.baseRoute}/${id}`);
  }
}
